document.addEventListener("DOMContentLoaded", () => {
  const swiperContainers = document.querySelectorAll("swiper-container[id^='swiper-']");

  swiperContainers.forEach((swiperEl) => {
    const swiperId = swiperEl.id;
    const uniqueId = swiperId.replace("swiper-", "");
    const pagination = document.getElementById(`custom-pagination-${uniqueId}`);
    const imageContainer = document.getElementById(`slide-image-container-${uniqueId}`);
    // Track the target slide that was clicked
    let targetSlideIndex = null;
    let isUserClick = false;

    const createBullet = (text, index, swiper) => {
      const btn = document.createElement("button");
      btn.className = `custom-bullet ${pagination.dataset.bulletCase}`;
      btn.textContent = text || index;
      btn.addEventListener("click", () => {
        // Mark that user clicked and which slide they want
        isUserClick = true;
        targetSlideIndex = index;
        swiper.slideTo(index);
      });
      return btn;
    };

    const createDivider = () => {
      const divider = document.createElement("span");
      divider.className = "bullet-divider";
      divider.textContent = "|";
      return divider;
    };

    const performImageTransition = (swiper, slideIndex) => {
      if (imageContainer) {
        const targetSlide = swiper.slides[slideIndex];
        const newImgSrc = targetSlide?.dataset.image;

        if (newImgSrc) {
          const imgElement = imageContainer.tagName === 'IMG'
            ? imageContainer
            : imageContainer.querySelector('img');

          if (imgElement) {
            const currentSrc = imgElement.src;
            const newSrcFull = newImgSrc.includes('http') ? newImgSrc : window.location.origin + newImgSrc;

            if (currentSrc !== newSrcFull) {
              const newImg = new Image();
              newImg.onload = () => {
                imgElement.style.opacity = '0';
                setTimeout(() => {
                  imgElement.src = newImgSrc;
                  imgElement.removeAttribute('srcset');
                  imgElement.removeAttribute('sizes');
                  imgElement.style.opacity = '1';
                }, 150);
              };
              newImg.src = newImgSrc;
            }
          }
        }
      }
    };

    const updateActiveBulletAndImage = (swiper) => {
      // Always update bullets
      const bullets = pagination.querySelectorAll(".custom-bullet");
      bullets.forEach((bullet, idx) => {
        bullet.classList.toggle("active", idx === swiper.realIndex);
      });

      // Only change image if:
      // 1. It's a user click AND
      // 2. We've reached the target slide they clicked
      if (isUserClick && swiper.realIndex === targetSlideIndex) {
        performImageTransition(swiper, targetSlideIndex);
        // Reset flags
        isUserClick = false;
        targetSlideIndex = null;
      } else if (!isUserClick) {
        performImageTransition(swiper, swiper.realIndex);
      }
    };

    const initPagination = () => {
      const swiper = swiperEl.swiper;
      if (!swiper || !pagination) {
        return setTimeout(initPagination, 100);
      }

      pagination.innerHTML = "";

      swiper.slides.forEach((slide, i) => {
        const text = slide.dataset.text;
        pagination.appendChild(createBullet(text, i, swiper));
        if (i < swiper.slides.length - 1) {
          pagination.appendChild(createDivider());
        }
      });

      swiper.on("slideChange", () => updateActiveBulletAndImage(swiper));
      updateActiveBulletAndImage(swiper);
    };

    initPagination();
  });
});
